import { Component, EventEmitter, Input, Output } from '@angular/core';

export type PlanCardVariant = 'base' | 'alert' | 'locator';

@Component({
  selector: 'app-plan-card',
  templateUrl: './plan-card.component.html',
  styleUrl: './plan-card.component.scss',
})
export class PlanCardComponent {
  @Input() variant: PlanCardVariant = 'base';
  @Input() title: string;
  @Input() subtitle?: string;
  @Input() price: string;
  @Input() monthlyPrice: string;
  @Input() originalPrice?: string;
  @Input() badgeText?: string;
  @Input() iconSrc?: string;
  /** Decorative swatches shown next to the icon. */
  @Input() colorOptions: string[] = [];
  /** Puts the product image beside the title instead of in the price row. */
  @Input() iconInHeader = false;
  @Input() inheritedLabel?: string;
  @Input() features: string[] = [];
  @Input() infoLine?: string;
  @Input() ctaText: string;
  @Input() ctaNote?: string;
  @Input() disabled = false;
  @Input() loading = false;
  @Input() showStripe = true;
  @Input() elevated = false;
  @Input() secondaryCtaText?: string;

  @Output() selectPlan = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<void>();

  /** Skips the row entirely when the visual moved to the header and there is no price. */
  get showPriceRow(): boolean {
    return !!(
      this.price ||
      this.originalPrice ||
      (!this.iconInHeader && (this.iconSrc || this.colorOptions.length))
    );
  }
}
